import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const msalConfig: Configuration = {
  auth: {
    clientId: '00198e60-c756-4475-9d82-862fd4fe219a', 
    authority: 'https://login.microsoftonline.com/f33cd7c9-99d6-4d11-82a6-15aa45b93e2f',     
    redirectUri: environment.redirectURL,
    postLogoutRedirectUri:environment.redirectURL
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
      //  console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
}
export const protectedResources = {
  ACESApi: {
    endpoint: environment.apiEndPointURI,
    scopes: ["api://f4ccde3d-afc1-4e5c-8079-f51c03107a36/ACES.Write"],
  },
}
export const loginRequest = {
  scopes: ['openid', 'profile', 'user.read','GroupMember.Read.All']
};